var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("赔付信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("结案状态")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.payoutInfo.isCloseName) || "-"))])]), _vm.payoutInfo.isClose != 0 ? _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("理赔结果")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.payoutInfo.resultName) || "-"))])]) : _vm._e(), _vm.payoutInfo.isClose != 0 ? _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("审核人")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.payoutInfo.reviewerName || "-"))])]) : _vm._e(), _vm.payoutInfo.isClose != 0 ? _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("结案时间")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.payoutInfo.closeCaseTime || "-"))])]) : _vm._e(), _vm.payoutInfo.isClose != 0 && _vm.payoutInfo.result == 1 ? _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("赔付金额")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(" " + _vm._s(_vm.payoutInfo.amount + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) || "-") + " ")])]) : _vm._e(), _vm.payoutInfo.isClose != 0 && _vm.payoutInfo.result == 1 ? _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("赔付时间")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.payoutInfo.payoutAt || "-"))])]) : _vm._e(), _vm.payoutInfo.isClose != 0 && _vm.payoutInfo.result == 2 ? _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("原因")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.payoutInfo.remark || "-"))])]) : _vm._e(), _vm.payoutInfo.isClose != 0 && _vm.payoutInfo.result == 1 ? _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("备注")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.payoutInfo.remark || "-"))])]) : _vm._e()])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };